import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { AreaSearchResult, POISearchResult } from '@alltrails/types/AlgoliaResults';
import { ExploreServiceState } from '../redux/exploreServiceSlice';
import ExploreServiceLocation from '../types/ExploreServiceLocation';
import useTrailEngagementRecordIds from './useTrailEngagementRecordIds';

const useLocationExploreServiceQueryArgs = (location?: AreaSearchResult | POISearchResult) => {
  const { boundingBox, filters, mapRotation, sort, trailEngagement } = useSelector(
    (state: { exploreService: ExploreServiceState }) => state.exploreService
  );

  const recordIds = useTrailEngagementRecordIds(trailEngagement);

  const filtersWithRecordIds = useMemo(() => {
    if (recordIds) {
      return { ...filters, hasTrails: true, recordIds };
    } else {
      return { ...filters, hasTrails: true };
    }
  }, [filters, recordIds]);

  const queryArgs = useMemo(
    () => ({
      filters: filtersWithRecordIds,
      limit: 30,
      location: {
        ...(boundingBox ?? { bottomLeft: undefined, bottomRight: undefined, topLeft: undefined, topRight: undefined }),
        mapRotation,
        ...(location ? { id: location.ID, placeType: location.location_type } : {})
      } as ExploreServiceLocation,
      sort
    }),
    [boundingBox, filtersWithRecordIds, mapRotation, location, sort]
  );

  return queryArgs;
};

export default useLocationExploreServiceQueryArgs;
